import React from 'react';
import { SparklesIcon, WrenchIcon, ChevronRightIcon } from 'lucide-react';
export function SuggerimentiSection() {
  return <div className="mb-8" data-id="element-751">
      <h2 className="text-sm font-semibold text-foreground mb-3" data-id="element-752">
        Suggerimenti
      </h2>
      <div className="flex flex-col gap-4" data-id="element-753">
        {/* Card 1: Ottimizzazione pulizie */}
        <div className="bg-white border border-border rounded-xl p-5" data-id="element-754">
          <div className="flex items-center gap-2.5 mb-3" data-id="element-755">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-muted flex items-center justify-center" data-id="element-756">
              <SparklesIcon size={15} className="text-foreground" data-id="element-757" />
            </div>
            <h3 className="text-sm font-semibold text-foreground" data-id="element-758">
              Ottimizza le pulizie
            </h3>
          </div>

          <div className="flex items-baseline gap-6 mb-2.5" data-id="element-759">
            <div data-id="element-760">
              <span className="text-2xl font-bold text-foreground" data-id="element-761">3</span>
              <span className="text-xs text-muted-foreground ml-1" data-id="element-762">
                pulizie condivisibili
              </span>
            </div>
            <div data-id="element-763">
              <span className="text-2xl font-bold text-[#FF4080]" data-id="element-764">€42</span>
              <span className="text-xs text-muted-foreground ml-1" data-id="element-765">
                di risparmio
              </span>
            </div>
          </div>

          <p className="text-xs text-muted-foreground leading-relaxed mb-3" data-id="element-766">
            In base ai prossimi check-in, puoi condividere il servizio con altri
            host in zona.
          </p>

          <button className="inline-flex items-center gap-1 text-xs font-medium text-foreground hover:text-foreground/70 transition-colors" data-id="element-767">
            Vedi opportunità
            <ChevronRightIcon size={14} data-id="element-768" />
          </button>
        </div>

        {/* Card 2: Tecnici in zona */}
        <div className="bg-white border border-border rounded-xl p-5" data-id="element-769">
          <div className="flex items-center gap-2.5 mb-3" data-id="element-770">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-muted flex items-center justify-center" data-id="element-771">
              <WrenchIcon size={15} className="text-foreground" data-id="element-772" />
            </div>
            <h3 className="text-sm font-semibold text-foreground" data-id="element-773">
              Risolvi le segnalazioni
            </h3>
          </div>

          <div className="flex items-baseline gap-6 mb-2.5" data-id="element-774">
            <div data-id="element-775">
              <span className="text-2xl font-bold text-foreground" data-id="element-776">3</span>
              <span className="text-xs text-muted-foreground ml-1" data-id="element-777">
                segnalazioni aperte
              </span>
            </div>
            <div data-id="element-778">
              <span className="text-2xl font-bold text-[#FF4080]" data-id="element-779">4</span>
              <span className="text-xs text-muted-foreground ml-1" data-id="element-780">
                tecnici in zona
              </span>
            </div>
          </div>

          <p className="text-xs text-muted-foreground leading-relaxed mb-3" data-id="element-781">
            La prossima settimana ci saranno tecnici disponibili: aggregati con
            altri host per costi ridotti.
          </p>

          <button className="inline-flex items-center gap-1 text-xs font-medium text-foreground hover:text-foreground/70 transition-colors" data-id="element-782">
            Vedi segnalazioni
            <ChevronRightIcon size={14} data-id="element-783" />
          </button>
        </div>
      </div>
    </div>;
}